/* Nestwell storefront interactions. Plain JS, no dependencies. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- ?for= ad targeting (runs first so the swapped content reveals normally) ---------- */
  function target() {
    var key = (new URLSearchParams(location.search).get('for') || '').toLowerCase().trim();
    if (!key) return;
    var spot = $('[data-nw-spot="' + key + '"]');
    if (!spot) return;
    var h = spot.getAttribute('data-hero-h'), s = spot.getAttribute('data-hero-s');
    var kick = $('[data-nw-kicker]'), sub = $('.nw-info__sub');
    if (h && kick) { kick.textContent = h; kick.hidden = false; }
    if (s && sub) sub.textContent = s;
    spot.classList.add('is-target');
    var buyWrap = ($('[data-nw-buy]') || {}).closest ? $('[data-nw-buy]').closest('.shopify-section') : null;
    var spotWrap = spot.closest('.shopify-section');
    if (buyWrap && spotWrap && buyWrap.parentNode === spotWrap.parentNode) buyWrap.parentNode.insertBefore(spotWrap, buyWrap.nextSibling);
  }

  /* ---------- reveal on scroll ---------- */
  function reveal() {
    var els = $$('.nw-rv');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
    // backup: reveal anything already scrolled into view, even if the observer is throttled
    var sweep = function () {
      var vh = window.innerHeight || 800;
      els.forEach(function (e) { if (!e.classList.contains('is-in') && e.getBoundingClientRect().top < vh * 0.95) e.classList.add('is-in'); });
    };
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('load', sweep); setTimeout(sweep, 600);
  }

  /* ---------- parallax backgrounds ---------- */
  function parallax() {
    var els = $$('[data-nw-par] img');
    if (!els.length || reduce) return;
    var tick = false;
    function run() {
      var vh = window.innerHeight;
      els.forEach(function (img) {
        var r = img.parentNode.parentNode.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (r.top + r.height / 2 - vh / 2) / vh;
        img.style.transform = 'translate3d(0,' + (p * -40).toFixed(1) + 'px,0) scale(1.06)';
      });
      tick = false;
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }

  /* ---------- countdowns (fixed end date, hide at zero) ---------- */
  function countdowns() {
    var els = $$('[data-nw-cd]');
    if (!els.length) return;
    function upd() {
      var now = Date.now();
      els.forEach(function (el) {
        var end = Date.parse(el.getAttribute('data-end'));
        var left = Math.floor((end - now) / 1000);
        if (isNaN(end) || left <= 0) { el.classList.add('is-over'); return; }
        var d = Math.floor(left / 86400), h = Math.floor(left % 86400 / 3600), m = Math.floor(left % 3600 / 60), s = left % 60;
        var set = function (sel, v) { $$(sel, el).forEach(function (n) { n.textContent = pad(v); }); };
        set('[data-d]', d); set('[data-h]', h); set('[data-m]', m); set('[data-s]', s);
      });
    }
    upd(); setInterval(upd, 1000);
  }

  /* ---------- live stage: mode toggle + photo thumbs ---------- */
  function stage() {
    var st = $('[data-nw-stage]');
    if (!st) return;
    $$('.nw-stage__mode button', st).forEach(function (b) {
      b.addEventListener('click', function () {
        var m = b.getAttribute('data-mode');
        st.setAttribute('data-mode', m); st.setAttribute('data-view', 'live');
        $$('.nw-stage__mode button', st).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        $$('[data-cap]', st).forEach(function (c) { c.hidden = c.getAttribute('data-cap') !== m; });
        $$('[data-nw-thumb]').forEach(function (t) { t.setAttribute('aria-pressed', t.getAttribute('data-nw-thumb') === 'live' ? 'true' : 'false'); });
      });
    });
    var photo = $('[data-nw-photo]', st);
    $$('[data-nw-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        var src = t.getAttribute('data-nw-thumb');
        $$('[data-nw-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        if (src === 'live') { st.setAttribute('data-view', 'live'); return; }
        photo.innerHTML = '<img src="' + src + '" alt="">';
        st.setAttribute('data-view', 'photo');
      });
    });
    // auto-flip modes once so visitors see both
    if (!reduce) setTimeout(function () {
      if (st.getAttribute('data-touched')) return;
      var a = $('.nw-stage__mode button[data-mode="amber"]', st), u = $('.nw-stage__mode button[data-mode="uv"]', st);
      if (a) { a.click(); setTimeout(function () { if (!st.getAttribute('data-touched') && u) u.click(); }, 2600); }
    }, 4200);
    st.addEventListener('pointerdown', function () { st.setAttribute('data-touched', '1'); });
  }

  /* ---------- packs + sticky ---------- */
  var packs = [], idInput, qtyInput;
  function selectPack(n, qty) {
    var lab = packs[n - 1];
    if (!lab) return;
    packs.forEach(function (p) { p.classList.toggle('is-on', p === lab); var i = $('input', p); if (i) i.checked = p === lab; });
    if (idInput && lab.getAttribute('data-id')) idInput.value = lab.getAttribute('data-id');
    if (qtyInput) qtyInput.value = qty || 1;
    var price = lab.getAttribute('data-price') || '';
    $$('[data-nw-price]').forEach(function (e) { e.textContent = (qty && qty > 1 ? qty + ' × ' : '') + price; });
    $$('[data-nw-sticky-pack]').forEach(function (e) { e.textContent = (qty && qty > 1 ? qty + ' × ' : '') + lab.getAttribute('data-name'); });
  }
  function buy() {
    var form = $('[data-nw-form]');
    if (!form) return;
    packs = $$('[data-nw-pack]', form);
    idInput = $('[data-nw-id]', form);
    qtyInput = $('input[name="quantity"]', form);
    packs.forEach(function (p, i) { p.addEventListener('click', function () { selectPack(i + 1); }); });
    var on = packs.filter(function (p) { return p.classList.contains('is-on'); })[0] || packs[0];
    selectPack(packs.indexOf(on) + 1);
    $$('[data-nw-pick]').forEach(function (b) {
      b.addEventListener('click', function () { selectPack(+b.getAttribute('data-nw-pick') || 1, +b.getAttribute('data-qty') || 1); });
    });
    form.addEventListener('submit', function () { var b = $('[data-nw-atc]', form); if (b) b.style.opacity = '.7'; });
    var sticky = $('[data-nw-sticky]'), atc = $('[data-nw-atc]', form);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (ents) {
        var e = ents[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }
  }

  /* ---------- delivery estimate ---------- */
  function eta() {
    $$('[data-nw-eta]').forEach(function (el) {
      var min = +el.getAttribute('data-min') || 5, max = +el.getAttribute('data-max') || 9, cut = +el.getAttribute('data-cutoff') || 14;
      var now = new Date(), wk = now.getDay() === 0 || now.getDay() === 6;
      var start = new Date(now);
      if (now.getHours() >= cut || wk) start.setDate(start.getDate() + 1);
      function addBiz(d, n) { var x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; } return x; }
      var a = addBiz(start, min), b = addBiz(start, max);
      var md = function (d) { return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' }); };
      var txt = a.getMonth() === b.getMonth() ? md(a) + ' – ' + b.getDate() : md(a) + ' – ' + md(b);
      $('[data-nw-eta-date]', el).textContent = txt;
      var c = $('[data-nw-eta-cut]', el);
      if (c && now.getHours() < cut && !wk) {
        var left = (cut * 60) - (now.getHours() * 60 + now.getMinutes());
        c.textContent = 'Ships in ' + (Math.floor(left / 60) ? Math.floor(left / 60) + 'h ' : '') + (left % 60) + 'm';
        c.hidden = false;
      }
    });
  }

  /* ---------- rooms calculator ---------- */
  function calc() {
    var c = $('[data-nw-calc]');
    if (!c) return;
    var out = $('[data-nw-rooms]', c), rec = $('[data-nw-rec]', c), btn = $('[data-nw-rec-btn]', c);
    var n = 2;
    function render() {
      out.textContent = n;
      var pack = n === 1 ? 1 : 2, qty = n <= 2 ? 1 : Math.ceil(n / 2);
      rec.textContent = n === 1 ? 'We recommend: 1 Lamp' : n === 2 ? 'We recommend: the 2-pack' : 'We recommend: ' + qty + ' × 2-pack (' + (qty * 2) + ' lamps)';
      btn.setAttribute('data-nw-pick', pack); btn.setAttribute('data-qty', qty);
    }
    $$('[data-nw-step]', c).forEach(function (b) {
      b.addEventListener('click', function () { n = Math.min(8, Math.max(1, n + (+b.getAttribute('data-nw-step')))); render(); });
    });
    render();
  }

  /* ---------- one-night slider ---------- */
  function night() {
    var sec = $('[data-nw-night]');
    if (!sec) return;
    var room = $('[data-nw-room]', sec), range = $('[data-nw-range]', sec), clock = $('[data-nw-clock]', sec),
        phase = $('[data-nw-phase]', sec), tray = $('[data-nw-tray]', sec), play = $('[data-nw-play]', sec);
    var phases = JSON.parse('[' + ($('[data-nw-phases]', sec) || {}).textContent + ']');
    var trays = JSON.parse('[' + ($('[data-nw-trays]', sec) || {}).textContent + ']');
    var bugs = $$('.nw-tray__cup i', sec);
    function set(v) {
      var t = v / 100;
      room.style.setProperty('--t', t);
      var mins = 22 * 60 + Math.round(t * 9 * 60), hh = Math.floor(mins / 60) % 24, mm = mins % 60;
      var ap = hh >= 12 ? 'PM' : 'AM', h12 = hh % 12 || 12;
      clock.innerHTML = h12 + ':' + pad(mm - mm % 5) + '<small>' + ap + '</small>';
      var pi = t < 0.22 ? 0 : t < 0.5 ? 1 : t < 0.86 ? 2 : 3;
      if (phase.getAttribute('data-i') !== String(pi)) { phase.textContent = phases[pi] || ''; phase.setAttribute('data-i', pi); }
      tray.textContent = trays[t < 0.08 ? 0 : t < 0.4 ? 1 : t < 0.86 ? 2 : 3] || '';
      bugs.forEach(function (b) { b.style.opacity = (+b.getAttribute('data-at') <= v) ? 1 : 0; });
    }
    range.addEventListener('input', function () { set(+range.value); });
    var anim;
    function run() {
      cancelAnimationFrame(anim);
      var t0 = null, from = +range.value >= 100 ? 0 : +range.value;
      function step(ts) {
        if (!t0) t0 = ts;
        var v = Math.min(100, from + (ts - t0) / 60);
        range.value = v; set(v);
        if (v < 100) anim = requestAnimationFrame(step);
      }
      anim = requestAnimationFrame(step);
    }
    play.addEventListener('click', run);
    range.addEventListener('pointerdown', function () { cancelAnimationFrame(anim); });
    set(0);
    if (!reduce && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.55 });
      io.observe(room);
    }
  }

  /* ---------- compare chips ---------- */
  function compare() {
    var sec = $('[data-nw-cmp]');
    if (!sec) return;
    var data = {};
    try { data = JSON.parse($('[data-nw-cmp-data]', sec).textContent); } catch (e) { return; }
    var name = $('[data-nw-cmp-name]', sec), verdict = $('[data-nw-cmp-verdict]', sec), cells = $$('[data-nw-cmp-cell]', sec);
    function show(k) {
      var d = data[k]; if (!d) return;
      var yes = (d.yes || '').split(',').map(function (x) { return x.trim(); });
      name.textContent = d.name;
      cells.forEach(function (c) {
        var ok = yes.indexOf(c.getAttribute('data-nw-cmp-cell')) > -1;
        c.className = 'nw-cmp__cell ' + (ok ? 'y' : 'n'); c.textContent = ok ? 'Yes' : 'No';
      });
      verdict.textContent = d.verdict;
      $$('[data-nw-cmp-btn]', sec).forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-nw-cmp-btn') === k ? 'true' : 'false'); });
    }
    $$('[data-nw-cmp-btn]', sec).forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-nw-cmp-btn')); }); });
    show('spray');
  }

  /* ---------- cart page ---------- */
  /* ---------- reserved-cart timer (survives the reloads qty changes cause) ---------- */
  function reserve() {
    var el = $('[data-nw-reserve]');
    if (!el) return;
    var mins = parseFloat(el.getAttribute('data-min')) || 3, key = 'nw_reserve_end', end = 0;
    try { end = +sessionStorage.getItem(key) || 0; } catch (e) {}
    if (!end) { end = Date.now() + mins * 60000; try { sessionStorage.setItem(key, end); } catch (e) {} }
    var t = $('[data-nw-reserve-t]', el), l = $('[data-nw-reserve-l]', el);
    var tick = function () {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      t.textContent = Math.floor(left / 60) + ':' + ('0' + left % 60).slice(-2);
      if (left <= 0) { el.classList.add('is-done'); l.textContent = el.getAttribute('data-done'); t.textContent = ''; clearInterval(iv); }
      else if (left <= 60) el.classList.add('is-low');
    };
    var iv = setInterval(tick, 1000); tick();
  }

  function cartPage() {
    var root = $('[data-nw-cart]');
    if (!root) return;
    var post = function (url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
    };
    var reload = function () { location.reload(); };
    $$('[data-nw-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var line = +b.closest('[data-line]').getAttribute('data-line');
        root.classList.add('is-busy');
        post('/cart/change.js', { line: line, quantity: Math.max(0, +b.getAttribute('data-nw-qty')) }).then(reload, reload);
      });
    });
    $$('[data-nw-upgrade]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        root.classList.add('is-busy');
        var line = +b.getAttribute('data-line'), qty = +b.getAttribute('data-qty') || 1, to = +b.getAttribute('data-to');
        post('/cart/change.js', { line: line, quantity: 0 })
          .then(function () { return post('/cart/add.js', { items: [{ id: to, quantity: qty }] }); })
          .then(reload, reload);
      });
    });
  }

  /* ---------- keep demo clips playing (iOS low power mode blocks autoplay) ---------- */
  function demos() {
    var vids = $$('.nw-demo video');
    if (!vids.length) return;
    var go = function () { vids.forEach(function (v) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }); };
    go();
    ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, go, { once: true, passive: true }); });
    vids.forEach(function (v) { v.addEventListener('click', function () { v.paused ? go() : null; }); });
  }

  /* ---------- review strip: three cards, one visible, fast rotation ---------- */
  function reviews() {
    $$('[data-nw-revs]').forEach(function (box) {
      var cards = $$('.nw-rev', box);
      if (!cards.length) return;
      cards[0].classList.add('is-on');
      var ms = +box.getAttribute('data-ms') || 2200;
      box.style.setProperty('--nw-rev-ms', ms + 'ms');
      if (cards.length < 2 || reduce) { box.classList.add('is-solo'); return; }
      var i = 0, t = null;
      var stop = function () { if (t) { clearInterval(t); t = null; } box.classList.add('is-paused'); };
      var start = function () {
        if (t) clearInterval(t);
        box.classList.remove('is-paused');
        t = setInterval(function () {
          cards[i].classList.remove('is-on');
          i = (i + 1) % cards.length;
          cards[i].classList.add('is-on');
        }, ms);
      };
      start();
      box.addEventListener('mouseenter', stop);
      box.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    });
  }

  function init() { reserve(); cartPage(); target(); reveal(); parallax(); countdowns(); stage(); buy(); eta(); calc(); night(); compare(); demos(); reviews(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
